import { cn } from '@qr-front/ui/utils'
import { ReactNode } from 'react'

export const HeaderContainer = ({
	children,
	className,
}: {
	children: ReactNode
	className?: string
}) => {
	return (
		<header
			className={cn(
				'sticky inset-0 left-0 right-0 top-0 z-10 h-16 w-full translate-x-0 content-center bg-white/80 px-3 py-2 backdrop-blur-2xl mobile:px-5 tablet:px-8 desktop:h-18 desktop:px-0 desktop:py-4',
				className,
			)}
		>
			{children}
		</header>
	)
}
